import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import RouteTitle from '../../../../presentation/RouteTitle';
import PageAuthorize from '../../../../security/PageAuthorize';
import EtelAPI from '../../../../api/EtelAPI';
import Alerts from '../../../../prototypes/Alerts';

import * as WjGrid from 'wijmo/wijmo.react.grid';
import * as wjcCore from 'wijmo/wijmo';

// Wijmo Key
wjcCore.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

// Wijmo styles
const getGridStyle = ( ) => ( {
  'width':'100%',
  'height':'96%',
  'text-align': 'center'
} );


class ASRTestScheduleList extends React.Component {

  constructor( props ){
    super( props );

    this.state = { rows: [] };

    // Value map for the columns to days
    this.vmap = { 1: 'MONDAY', 2: 'TUESDAY', 3: 'WEDNESDAY', 4: 'THURSDAY', 5: 'FRIDAY', 6: 'SATURDAY', 7: 'SUNDAY' };

    // Component State
    this._ismounted = false;

    // Alerts
    this.alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
    this.alert_title = 'ASR Test Port Settings';

    // Wijmo reference
    this.wijmopanel = undefined;

    // Bindings
    this.renderGrid = this.renderGrid.bind( this );
    this.drawCell = this.drawCell.bind( this );
    this.onCreateTabBar = this.onCreateTabBar.bind( this );
    this.saveChanges = this.saveChanges.bind( this );
    this.validateValue = this.validateValue.bind( this );
    this.updateValue = this.updateValue.bind( this );
    this.getValues = this.getValues.bind( this );
    this.doLogOff = this.doLogOff.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
  }

  /* Loads results on component mounting, sets allow render flag on */
  componentDidMount(){
    this._ismounted = true;
    this.getValues();
  }

  // Turns off renders if the component is not mounted
  componentWillUnmount(){
    this._ismounted = false;
  }

  // Logs the user off the site if creds expired
  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  // Handles exceptions on request
  onHandleException( e ) {
    if( this._ismounted === true ){
      const status = e.status === undefined ? 0 : e.status;
      
      if( status === 410 ) {
        this.alerts.INFO( this.alert_title, 'Your session has expired.' , 5000 );
        this.doLogOff();
      } else if( status === 500 ) {
        this.alerts.INFO( this.alert_title, e.statusText , 5000 );
        this.doLogOff();
      
      // This only needs to warn the user, in this case a 400 is an invalid request
      } else if( status === 400 ) {
        this.alerts.WARNING( this.alert_title, 'Invalid Request', 8000 );
      } else {
        this.alerts.CRITICAL( this.alert_title, e );
      }
    }
  }

  // Gets all current values
  getValues(){
    let api = new EtelAPI( 'technical/asrtestports' );
    
    // Retrieving the information from the backend
    api.get( {} ).then( ( results ) => {
      if( this._ismounted === true ){
        this.renderGrid( results );
      }
    } ).catch( ( error ) => {
      this.onHandleException( error ); 
    } );
  }

  // Updates a new percentage
  updateValue( nvalue, col, row ){
    let api = new EtelAPI( 'technical/asrtestports' );
    // Retrieving the information from the back-end
    api.update( [{'DAY':col, 'HOUR':row, 'VALUE':nvalue}] ).then( ( results ) => {
      if( this._ismounted === true ){
        this.alerts.SUCCESS( 'ASR Test Port', 'Successfully updated percentage', 5000 );
        this.getValues();
      }
    } ).catch( ( error ) => {
      // Reset values
      this.getValues();
      this.onHandleException( error );
    } );
  }

  // Draws the hour portion of the grid, this as html content
  drawCell( value ){

    // Pads the value if needed
    if( value < 10 ){
      value = '0' + String( value );
    } else {
      value = String( value );
    }

    let renderhtml = '<div style="display:flex; flex-direction:row; background-color:#EAEAEA; border: 1px solid #D4D4D4; margin-top: -1px; user-select: none; color: black;">';
    return renderhtml + '<div style="line-height:21px; height:19px; width:50px; text-align:center; font-weight:900;">' + value + '</div></div>';
  }

  // Creates the ASR Test Port Settings header
  onCreateTabBar(){
    return(
      <div className={'tab-selection-bar'} style={{backgroundColor: '#FAFAFA'}}>
        <button className={'new-grid-view-tab-button-selected'}>ASR Test</button>
      </div>
    );
  }

  // After an edit is complete
  saveChanges( e, grid ){
    // Positions
    const col = grid['col'];
    const row = grid['row'];

    // Data, this will ignore none numeric values and will convert negative numbers to positive
    const data_rows = grid.panel.rows;
    const value = this.validateValue( data_rows[row]._data[ this.vmap[col] ] );
    this.updateValue( value, col, row );
  }

  // Validates that utilization is not over 100%, converts values bigger than 1 to 1
  validateValue( value ){

    // Wijmo will reset none numeric values to what was in the row before, no edit
    let nvalue = Math.abs( value );
    if( nvalue <= 1 ){
      return nvalue;
    } else {
      this.alerts.WARNING( 'ASR Test Port', 'Max value allowed is 100% or 1', 7000 );
      // Returns 1 on overflow
      return 1;
    }
  }

  // Gets the schedule information (debugging data)
  renderGrid( rows ){
    let ngrid = [];

    // Adds the html cell
    for( let i = 0; i < rows.length; i++ ){
      let r = rows[i];
      r['HOUR_OF_DAY'] = this.drawCell( r['HOUR_OF_DAY'] );
      ngrid.push( r );
    }

    // Sets the altered grid as the row
    this.setState( {
      rows: ngrid
    } );
  }

  render(){
    return(
      <PageAuthorize groups={['Administrators','Operations']} key={'asr-port-schedule-key'}>
        <div className='change-management-logs-container' key={'asr-port-schedule-view-key'}>
          <div className='change-management-log-view'>
            
            <RouteTitle title='ASR Test Ports' />
            <div className='page-header' style={{marginTop: 0}}>
              <div> ASR Test Port Settings </div>
            </div>

            {this.onCreateTabBar()}

            <div className={'list-grid-body'}>
              <WjGrid.FlexGrid
                ref={( panel ) => this.wijmopanel = panel}
                autoGenerateColumns={false}
                allowDragging={0}
                itemsSource={this.state.rows}
                selectionMode="CellRange"
                autoClipboard={true}
                allowAddNew={false}
                allowDelete={false}
                style={ getGridStyle() }
                allowSorting={false}
                cellEditEnded={this.saveChanges}>
                <WjGrid.FlexGridColumn header="Hour" binding="HOUR_OF_DAY" width={60} isReadOnly={true} isContentHtml={true} />
                <WjGrid.FlexGridColumn header="Monday" binding="MONDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Tuesday" binding="TUESDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Wednesday" binding="WEDNESDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Thursday" binding="THURSDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Friday" binding="FRIDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Saturday" binding="SATURDAY" width="1*" isReadOnly={false} />
                <WjGrid.FlexGridColumn header="Sunday" binding="SUNDAY" width="1*" isReadOnly={false} />
              </WjGrid.FlexGrid>
            </div>
          
          </div>
        </div>
      </PageAuthorize>
    );
  }
}


export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( ASRTestScheduleList ) );


// WEBPACK FOOTER //
// ./src/content/technical/asr/components/ASRTestSchedule.js